export default __webpack_public_path__ + "static/media/guide-4.db1ff982.png";